var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRightSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60953 6.84756C8.13016 6.37901 8.13016 5.61807 7.60953 5.14952L2.27828 0.35152C1.89509 0.00666394 1.32448 -0.0945439 0.824678 0.0928779C0.324873 0.2803 0 0.715118 0 1.20241V10.7984C0 11.282 0.324873 11.7205 0.824678 11.908C1.32448 12.0954 1.89509 11.9904 2.27828 11.6493L7.60953 6.85131V6.84756Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRightSolid);
export default __webpack_public_path__ + "static/media/caret-right-solid.3a794f257db66a41234b7a9759e6c5cf.svg";
export { ForwardRef as ReactComponent };